import { useQuery } from '@tanstack/react-query';
import { listLitters } from '@/api/entities/litters';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';

type ListLittersParams = {
  litterType?: string;
};

type QueryFnType = typeof listLitters;

type UseLittersOptions = {
  queryParams?: ListLittersParams;
  config?: QueryConfig<QueryFnType>;
};

export const useLitters = ({ queryParams, config }: UseLittersOptions = {}) => {
  const { getAccessToken } = useCognitoAuth();

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['litters', queryParams?.litterType].filter((value) => value !== undefined),
    queryFn: () => listLitters(queryParams?.litterType, getAccessToken),
  });
};
